<template>
  <div class="my_navbar">
    <img v-if="leftBtn" src="@/assets/images/Return@2x.png" alt="" @click="goback">
    <!--    只跳转不搜索-->
    <router-link to="search" v-if="focusSearch" class="fake_search">
      <img src="@/assets/images/search@2x.png" alt="">
      <span>商品关键词或货号</span>
    </router-link>
<!--    需要搜索-->
    <div class="my_search" v-else>
      <img src="@/assets/images/search@2x.png" alt="">
      <nut-textinput
        :has-border="false"
        class="my_input"
        type="search"
        :placeholder="placeText"
        v-model="searchName"
        ref="myInput"
        @keyup.enter="searchGoods" />
      <div class="searchBtn" @click="searchGoods">搜索</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'searchNavbar',
  props: {
    placeText: {
      type: String,
      default: '商品关键词或货号'
    },
    data: {
      type: String,
      default: ''
    },
    leftBtn: {
      type: Boolean,
      default: true
    },
    focusSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchName: null
    }
  },
  mounted() {
    console.log('this.searchName', this.searchName)
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    searchGoods() {
      console.log('提交')
      this.$emit('search', this.searchName)
    }
  },
  watch: {
    data: {
      handler(value) {
        this.searchName = value
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .my_navbar {
    display: flex;
    align-items: center;
    width: 95%;
    padding-top: 10px;
    margin: 0 auto 10px;

    img {
      width: 11px;
      height: 19px;
      margin-right: 10px;
    }

    .my_bar {
      flex: 1;
    }

  }

  /*搜索框*/
  .fake_search {
    width: 100%;
    margin: 0 auto;
    color: #999999;
    height: 30px;
    display: flex;
    align-items: center;
    background: #F2F2F2;
    border-radius: 15px;
    padding: 0 10px;

    > p {
      margin-left: 10px;
      font-size: 13px;
      color: $primary-color;
    }
    img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
  }
  .my_search{
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
    .my_input{
      flex:1;
    }
    img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
      position: absolute;
      top: 50%;
      left: 10px;
      z-index: 1;
      margin-top: -8px;
    }
  }
  .searchBtn{
    margin-left: 10px;
    font-size: 13px;
    color: $primary-color;
  }
</style>
<style>

  .my_input.nut-textinput input{
    height:30px;
    background: #F2F2F2;
    border-radius:15px;
    font-size: 12px;
    padding-left: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbars/searchNavbar.vue